export const CREATE_STRIPE_INTEGRATION = 'NURSERY_INTEGRATIONS/CREATE_STRIPE_INTEGRATION'
export const CREATE_STRIPE_INTEGRATION_SUCCESS = 'NURSERY_INTEGRATIONS/CREATE_STRIPE_INTEGRATION_SUCCESS'
export const CREATE_STRIPE_INTEGRATION_FAILED = 'NURSERY_INTEGRATIONS/CREATE_STRIPE_INTEGRATION_FAILED'

export const UPDATE_STRIPE_CAPABILITY = 'NURSERY_INTEGRATIONS/UPDATE_STRIPE_UPDATE'
export const UPDATE_STRIPE_CAPABILITY_SUCCESS = 'NURSERY_INTEGRATIONS/UPDATE_STRIPE_CAPABILITY_SUCCESS'
export const UPDATE_STRIPE_CAPABILITY_FAILED = 'NURSERY_INTEGRATIONS/UPDATE_STRIPE_CAPABILITY_FAILED'

export const CLEAR_STRIPE_INTEGRATION = 'NURSERY_INTEGRATIONS/CLEAR_STRIPE_INTEGRATION'
